import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";
import './style.scss'
const ProfileSlider = ({ items = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!items.length) {
    return <p className="text-center mb-0">No profile to show yet.</p>;
  }

  // Swiper needs roughly twice the visible slides for a stable infinite loop
  const canLoop = items.length >= 6;
  const slidesPerView = Math.min(3, items.length);

  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      spaceBetween={20}
      slidesPerView={slidesPerView}
      centeredSlides={canLoop}
      loop={canLoop}
      autoplay={canLoop ? { delay: 3000 } : false}
      onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      breakpoints={{
        0: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        768: {
          slidesPerView: Math.min(2, items.length),
          centeredSlides: false,
        },
        1024: {
          slidesPerView: slidesPerView,
          centeredSlides: canLoop,
        },
      }}
    >
      {items.map((item, index) => {
        const showDetails = !canLoop || index === activeIndex

        return (
          <SwiperSlide key={item._id || index}>
            <div className={`card ${canLoop && index === activeIndex ? "active" : ""} border-0`}>
              <Link to={`/single-profile/${item?._id}`}>
                <img
                  src={item?.images?.[0]?.name}
                  alt={item?.name}
                  className="img-fluid"
                />
              </Link>

              {showDetails && (
                <div className="details">
                  <h4>{item?.name}</h4>
                  <p>{item?.professionArea || item?.workingWith || item?.city || ''}</p>
                </div>
              )}
            </div>
          </SwiperSlide>
        )
      })}
    </Swiper>
  );
};

export default ProfileSlider;
